import {

    // Arrendamientos
    LeasesApplies,
    LeasesContracts,
    LeasesPayments,
    LeasesManagements,
    FormManagement,

    // Vehículos
    VehiclesApplies,
    VehiclesSales,
    VehiclesPayments,
    VehiclesManagements,
    FormVehiclesManagement,
    VehiclesCredits,
    ManagementUncollectibleCredits,

    // Créditos
    Credits,
    CreditsApplies,
    CreditsPayments,
    CreditsManagements,
    FormCreditsManagement,
    CreditsCollateral,
    UncollectibleCredits,

    // Gestiones Generales
    GeneralManagements


} from "components/Managements";

const routesManagements = [
    {
        path: null,
        name: "Arrendamientos",
        icon: "nc-icon nc-paper",
        component: null,
        permissions: ['94_ARRENDAMIENTOS'], //TODO: Cambiar permiso
        layout: null,
        visibility: true,
        subRoutes: [
            {
                path: "/gestiones-arrendamientos-contratos",
                name: "Contratos",
                icon: "nc-icon nc-paper",
                component: <LeasesContracts />,
                permissions: ['211_ARRENDAMIENTOS_CONTRATOS'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/gestiones/arrendamientos/solicitudes",
                name: "Solicitudes",
                icon: "nc-icon nc-paper",
                component: <LeasesApplies />,
                permissions: ['96_ARRENDAMIENTOS_SOLICITUDES'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/gestiones/arrendamientos/pagos",
                name: "Pagos",
                icon: "nc-icon nc-paper",
                component: <LeasesPayments />,
                permissions: ['97_ARRENDAMIENTOS_PAGOS'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/gestiones/arrendamientos/gestiones",
                name: "Otras gestiones",
                icon: "nc-icon nc-paper",
                component: <LeasesManagements />,
                permissions: ['98_ARRENDAMIENTOS_GESTIONES'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/gestiones-arrendamientos-form",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <FormManagement />,
                permissions: ['98_ARRENDAMIENTOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/gestiones-arrendamientos-form/edit/:idgestion",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <FormManagement />,
                permissions: ['98_ARRENDAMIENTOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/gestiones-arrendamientos-form/info/:idgestion",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <FormManagement />,
                permissions: ['98_ARRENDAMIENTOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            }
        ],
    },
    {
        path: null,
        name: "Vehículos",
        icon: "nc-icon nc-paper",
        component: null,
        permissions: ['100_VEHICULOS'],
        layout: null,
        visibility: true,
        subRoutes: [
            {
                path: "/gestiones-vehiculos-ventas",
                name: "Ventas",
                icon: "nc-icon nc-paper",
                component: <VehiclesSales />,
                permissions: ['101_VEHICULOS_VENTAS'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/gestiones-vehiculos-creditos",
                name: "Creditos",
                icon: "nc-icon nc-paper",
                component: <VehiclesCredits />,
                permissions: ['204_VEHICULOS_CREDITOS'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/gestiones-vehiculos-solicitudes",
                name: "Solicitudes",
                icon: "nc-icon nc-paper",
                component: <VehiclesApplies />,
                permissions: ['102_VEHICULOS_SOLICITUDES'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/gestiones-vehiculos-pagos",
                name: "Pagos",
                icon: "nc-icon nc-paper",
                component: <VehiclesPayments />,
                permissions: ['103_VEHICULOS_PAGOS'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/gestiones-vehiculos-gestiones",
                name: "Gestiones",
                icon: "nc-icon nc-paper",
                component: <VehiclesManagements />,
                permissions: ['104_VEHICULOS_GESTIONES'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/gestiones-vehiculos-form",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <FormVehiclesManagement />,
                permissions: ['104_VEHICULOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/gestiones-vehiculos-form/edit/:idgestion",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <FormVehiclesManagement />,
                permissions: ['104_VEHICULOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/gestiones-vehiculos-form/info/:idgestion",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <FormVehiclesManagement />,
                permissions: ['104_VEHICULOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/gestiones-vehiculos-creditos-incobrables",
                name: "Creditos Incobrables",
                icon: "nc-icon nc-paper",
                component: <ManagementUncollectibleCredits />,
                permissions: ['208_VEHICULOS_CREDITOS_INCOBRABLES'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            }
        ],
    },
    {
        path: null,
        name: "Creditos",
        icon: "nc-icon nc-paper",
        component: null,
        permissions: ['106_CREDITOS'],
        layout: null,
        visibility: true,
        subRoutes: [
            {
                path: "/gestiones-creditos-creditos",
                name: "Creditos",
                icon: "nc-icon nc-paper",
                component: <Credits />,
                permissions: ['235_CREDITOS'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },

            {
                path: "/gestiones-creditos-solicitudes",
                name: "Solicitudes",
                icon: "nc-icon nc-paper",
                component: <CreditsApplies />,
                permissions: ['107_CREDITOS_SOLICITUDES'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/gestiones-creditos-pagos",
                name: "Pagos",
                icon: "nc-icon nc-paper",
                component: <CreditsPayments />,
                permissions: ['108_CREDITOS_PAGOS'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/gestiones-creditos-gestiones",
                name: "Gestiones",
                icon: "nc-icon nc-paper",
                component: <CreditsManagements />,
                permissions: ['109_CREDITOS_GESTIONES'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/gestiones-creditos-form",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <FormCreditsManagement />,
                permissions: ['109_CREDITOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/gestiones-creditos-form/edit/:idgestion",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <FormCreditsManagement />,
                permissions: ['109_CREDITOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/gestiones-creditos-form/info/:idgestion",
                name: "Formulario Gestiones",
                icon: "nc-icon nc-paper",
                component: <FormCreditsManagement />,
                permissions: ['109_CREDITOS_GESTIONES'],
                layout: "/app",
                visibility: false,
                subRoutes: [],
            },
            {
                path: "/gestiones-creditos-garantias",
                name: "Garantias",
                icon: "nc-icon nc-paper",
                component: <CreditsCollateral />,
                permissions: ['239_CREDITOS_GARANTIAS'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },
            {
                path: "/gestiones-creditos-incobrables",
                name: "Creditos Incobrables",
                icon: "nc-icon nc-paper",
                component: <UncollectibleCredits />,
                permissions: ['236_CREDITOS_INCOBRABLES'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            }
        ],
    },
    {
        path: null,
        name: "Gestiones Generales",
        icon: "nc-icon nc-paper",
        component: null,
        permissions: ['248_GESTIONES_GENERALES'],
        layout: null,
        visibility: true,
        subRoutes: [
            {
                path: "/gestiones/generales/activas",
                name: "Gestiones Activas",
                icon: "nc-icon nc-paper",
                component: <GeneralManagements />,
                permissions: ['249_GESTIONES_ACTIVAS'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            },

            {
                path: "/gestiones/generales/cerradas",
                name: "Gestiones Cerradas",
                icon: "nc-icon nc-paper",
                component: <GeneralManagements />,
                permissions: ['250_GESTIONES_CERRADAS'],
                layout: "/app",
                visibility: true,
                subRoutes: [],
            }
        ],
    },
];

export {
    routesManagements
}